export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M2.5 5h2v6h5V5h2v14h-2v-6h-5v6h-2zm19 12v2h-7v-6a2 2 0 0 1 2-2h3V7h-5c0-1 1-2.045 2-2h2q0-.003 1-.003c1 0 2 1.003 2 2.003v4a2 2 0 0 1-2 2h-3v4z\"/>"
};